import * as React from "react";
import { Modal } from "antd";
import ViewTradeCommissionModal from "./ViewTradeCommissionModal";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useState } from 'react';
import { ITrade } from 'src/services/interfaces/trade/ITrade';
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import Tooltip from "../Tooltip/Tooltip";
import ViewCommissionModal from "./ViewCommissionModal";

interface IViewTradeCommissionButton {
  currentTrade: ITrade;
  reloadTrade: (tradeID: number) => void;
}

export function ViewTradeCommissionButton(props: IViewTradeCommissionButton) {
  const [showModal, setShowModal] = useState(false);

  const wfPhases = [TradePhaseEnum.Created, TradePhaseEnum.ContractInformation, TradePhaseEnum.LegalCertificates, TradePhaseEnum.DocumentValidation, TradePhaseEnum.DocumentApproval, TradePhaseEnum.SpecialProjectApproved, TradePhaseEnum.SpecialProjectValid, TradePhaseEnum.Diligence, TradePhaseEnum.Analysis, TradePhaseEnum.PreSpecialSituation];

  const isButtonDisabled = !wfPhases.includes(props.currentTrade.phase);

  return (
    <>
      <Tooltip text={isButtonDisabled ? "Trade bloqueado para edição devido a sua fase atual" : null}>
        <button
          className="view-commission btn"
          onClick={() => setShowModal(true)}
          disabled={isButtonDisabled}
        >
          <FontAwesomeIcon icon={faEye} />
          Editar comissão
        </button>
      </Tooltip>
      <Modal className="modal-view-trade-commission" title="Editar Comissão" visible={showModal} footer={[]} onCancel={() => setShowModal(false)} maskClosable={false}>

        {showModal && props.currentTrade.isSpecialProject &&
          <ViewTradeCommissionModal
            currentTrade={props.currentTrade}
            reloadTrade={props.reloadTrade}
            setShowModal={setShowModal}
          />
        }
        {showModal && !props.currentTrade.isSpecialProject &&
          <ViewCommissionModal
            currentTrade={props.currentTrade}
            onCommissionUpdated={() => {
              setShowModal(false)
            }} />
        }
      </Modal>
    </>
  );
}

export default ViewTradeCommissionButton;



// WEBPACK FOOTER //
// ./src/components/common/CommissionView/ViewTradeCommissionButton.tsx